import '@stripe/stripe-js';
import { configure } from 'mobx';
import * as React from 'react';
import { render as DOMRender } from 'react-dom';
import { BugsnagEventLogger, EventLogger } from '../models/Logging';
import { polyfillAsync } from '../models/UiUtils';
import { SonnerToast } from '../web/components/SonnerToast';
import { ErrorModalProvider } from './components/ErrorModalProvider';
import { SurveyApp } from './containers/SurveyApp';
import { ApiClientContextProvider } from './context';
import './styles/global-styles.less';

const bugsnagEventLogger = new BugsnagEventLogger(import.meta.env.MODE);
const ErrorBoundary = bugsnagEventLogger.getErrorBoundary();
EventLogger.addLogger(bugsnagEventLogger);

document.addEventListener('DOMContentLoaded', async () => {
	await polyfillAsync();
	const rootElement = document.getElementById('react-root');
	configure({ enforceActions: 'never' });
	DOMRender(
		<ErrorBoundary>
			<React.StrictMode>
				<ApiClientContextProvider>
					<ErrorModalProvider>
						<SurveyApp />
						<SonnerToast />
					</ErrorModalProvider>
				</ApiClientContextProvider>
			</React.StrictMode>
		</ErrorBoundary>,
		rootElement
	);
});
